import { QueryClient } from "@tanstack/react-query"

function createQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 1000 * 30,
        gcTime: 1000 * 60 * 5,
        retry: 1,
      },
    },
  })
}

// The browser's single, app-lifetime cache.
export const queryClient = createQueryClient()

// The cache a render should use. In the browser that's the shared one above. On
// the server it's a fresh one per render: server-rendered routes (the guide
// view) seed loader data into the cache, and a module-level cache would carry
// one request's data into the next — stale guides after a republish, and an
// ever-growing cache in the long-lived server process.
export function getRenderQueryClient(): QueryClient {
  return typeof window === `undefined` ? createQueryClient() : queryClient
}
